import { IconLock, IconVolume } from '@tabler/icons-react'
import { useTranslation } from 'react-i18next'
import styles from './AudioGuideButton.module.css'

type Props = {
  active?: boolean
  /** 有効範囲外のときロック表示にする（クリックでダイアログを表示するため disabled にしない） */
  locked?: boolean
  /** 位置情報取得中はスケルトン表示にして disabled にする */
  loading?: boolean
  onClick?: () => void
  className?: string
  /** アイコン下にラベルを表示するか（デフォルト: true） */
  showLabel?: boolean
  /** ラベル文字列（省略時は i18n の 'spot_detail.audio_guide.title' を使用） */
  label?: string
}

export function AudioGuideButton({
  active = false,
  locked = false,
  loading = false,
  onClick,
  className,
  showLabel = true,
  label,
}: Props) {
  const { t } = useTranslation()
  const resolvedLabel = label ?? t('spot_detail.audio_guide.title', '音声ガイド')

  return (
    <div className={`${styles.wrapper} ${className ?? ''}`}>
      <button
        type="button"
        className={`${styles.button} ${active ? styles.active : ''} ${locked ? styles.locked : ''} ${loading ? styles.loading : ''}`}
        onClick={onClick}
        aria-label={
          locked
            ? t('spot_detail.audio_guide.aria_out_of_range', '音声ガイドは有効範囲外です')
            : active
              ? t('spot_detail.audio_guide.aria_stop', '音声ガイドを停止')
              : t('spot_detail.audio_guide.aria_play', '音声ガイドを再生')
        }
        aria-pressed={active}
        disabled={loading}
      >
        {locked ? (
          <IconLock size={20} stroke={1.5} aria-hidden="true" />
        ) : (
          <IconVolume size={20} stroke={1.5} aria-hidden="true" />
        )}
      </button>
      {showLabel && <span className={styles.label}>{resolvedLabel}</span>}
    </div>
  )
}
